import cn from 'classnames';

import styles from './LoadingSkeleton.module.scss';

type Props = {
  className?: string;
};

const LoadingSkeleton = ({ className }: Props) => (
  <div className={cn(styles.container, className)}>
    <div className={styles.skeleton} />
  </div>
);

export default LoadingSkeleton;
